import { render } from "./MiniBrandIntro.vue?vue&type=template&id=2fb013a8&scoped=true"
import script from "./MiniBrandIntro.vue?vue&type=script&lang=js"
export * from "./MiniBrandIntro.vue?vue&type=script&lang=js"

import "./MiniBrandIntro.vue?vue&type=style&index=0&id=2fb013a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb013a8"]])

export default __exports__